import { shallowEqual, useSelector } from "react-redux";
import type { RootState } from "~/app/store";
import type { ProductDescriptor } from "~/domains/product/types/ProductDescriptor";
import { useRegularPnaProductDescriptors } from "~/domains/pna/useRegularPnaProductDescriptors";

/**
 * Per-result-row SRP/PLP descriptors from the canonical PnA queries (task 0042, A05 slice 4).
 *
 * Basic products are staged by `SEARCH_SUCCESS` into `products.basic` and feed the descriptors'
 * BASE data only — the code-based queries run for every code, staged or not. CONFIGURATOR
 * results use the domain hook's configurator exclusion — the legacy `selectProductDescriptor`
 * mapping for configurators.
 */
export function useSrpProductDescriptors(productCodes: string[], priceReference: string): ProductDescriptor[] {
  const bases = useSelector(
    (state: RootState) => productCodes.map((productCode) => state.products.basic[productCode]),
    shallowEqual,
  );

  return useRegularPnaProductDescriptors(
    productCodes.map((productCode, index) => ({
      storefrontCode: productCode,
      base: bases[index],
      priceReference,
    })),
  );
}
